import { __decorate } from "tslib";
import { getInstance } from '../../../../services/animation';
import CaptionComponent from '../../Component/components/CaptionComponent';
import '../../Component/components/ImageComponent';
import '../../Component/components/TextComponent';
import '../../editor.store';
import { declareComponents } from '../../modules';
import HideDelete from '../Default/HideDelete.svelte';
import Layer from '../Default/Layer.svelte';
import FontSelect from '../Text/FontSelect.svelte';
import '../Text/FontSize.svelte';
import FontStyle from '../Text/FontStyle.svelte';
import TextAlignment from '../Text/TextAlignment.svelte';
import TextColor from '../Text/TextColor.svelte';
let CaptionModule = class CaptionModule {
    toolbarActions = [
        {
            component: FontSelect
        },
        {
            component: TextColor
        },
        {
            component: FontStyle
        },
        {
            component: TextAlignment
        },
        {
            component: Layer
        },
        {
            component: HideDelete
        }
    ];
    onResize(component) {
        const size = 1000;
        const instance = getInstance();
        if (instance) {
            instance.templateLoader.recomputeTemplateMetadata();
            instance.recomputeCaptionTextSize();
        }
    }
};
CaptionModule = __decorate([
    declareComponents([CaptionComponent])
], CaptionModule);
export default CaptionModule;
